import React from 'react';
import { Dropdown, Menu } from "antd";
import styles from "./scss/automatedMints.module.scss";
import {
  PDfSharenDownload,
  wordSharenDownnload
} from '../../../../base/callService/common';

export const DownloadFile = () => {
  let srcTag: any = document.getElementById("editor")?.innerHTML;
  const downloaddocument = (
    <Menu>
      <Menu.Item>
        <a href="#/" target="#" onClick={()=>PDfSharenDownload(true,srcTag)}>Pdf</a>
      </Menu.Item>
      <Menu.Item>
        <a href="#/" target="#" onClick={()=>wordSharenDownnload(true,srcTag)}>Word</a>
      </Menu.Item>
    </Menu>
  );

  return (<>
    <Dropdown placement="bottomRight" className={styles.callsSummaryBtn}
      overlay={downloaddocument} trigger={['click']}>
      <span className="icon_Downloadstroke"></span>
    </Dropdown>
  </>);
};